import styled from 'styled-components';
import { ControlButtons, dialogContentStyle } from '../index.styled';

export const DialogBodyContent = styled.div`
    ${dialogContentStyle};
`;
export const DialogBodyControlButtons = styled(ControlButtons)``;
